module.exports = __webpack_public_path__ + "static/together-bbe45811e33827ddcc5f58a0a8dd73c7.jpg";